export default __webpack_public_path__ + "static/media/cowboy-flushed-emoji.71cf72c4.jpg";